import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../Dashboard";

export const adminsRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "admins",
}).lazy(() => import("./Admins.lazy").then((d) => d.Route));
